import script from "./PersonalfragenHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalfragenHeader.vue?vue&type=script&setup=true&lang=js"

import "./PersonalfragenHeader.vue?vue&type=style&index=0&id=19f10f10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19f10f10"]])

export default __exports__